import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";

import { Grid, Box, Typography, Button, Tooltip, CircularProgress, Checkbox, FormControlLabel } from '@mui/material';
import { getMLMuserAPI } from 'api/CoreMlmmgmtWebServices';
import MlmBenefits from './MlmBenfits';
import MlmProcess from './MlmProcess';
import MlmTandC from './MlmTandC';
import { setselectedPkgObj } from 'store/slice/EcomSlice';
import { use } from 'react';


export default function MlmPartnershipProcess() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { mlmUserObj, partnerAPISuccess } = useSelector((state) => state.ecomslice.mlm);
  const [apiInProgress, setApiInProgress] = useState(false);
  useEffect(() => {
    setselectedPkgObj(null);
  });
  return (
    <>
        <Grid container justifyContent="flex-end" sx={{ width: '100%', padding: 1, maxHeight: '73vh' }} alignItems="center">
          <Grid item xs={12} sx={{ mt: 2, mb: 1 }}>
            <Typography variant="h4" color="primary.darker">Onboarding @ Business Associate</Typography>
          </Grid>
          <Grid item xs={12} sx={{ backgroundColor: 'white', padding: 1, borderRadius: 2 }}>
            <Typography variant="h6" >Welcome to G&N Business Associate Program. This Onboarding process will guide you to become G&R Business Associate.</Typography>
          </Grid>
          <Grid item xs={12} sx={{ mt: 1 }}>
            <Typography variant="h5" color="primary.darker">Business Associate Benefits</Typography>
          </Grid>
          <Grid item xs={12}>
            <Box lg={12} sx={{ flexGrow: 1 }}>
              <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: '48vh' }}>
                <MlmBenefits />
              </Grid>
            </Box>
          </Grid>
        </Grid>
      
      <Grid item sx={{  }}>
        <MlmTandC />
      </Grid>
    </>
  )
}